import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

/**
 * StaticComponent is responsible for displaying static content based on the provided object input.
 * 
 * When routing to this component, the URL should include a query parameter named 'object' which determines
 * the specific static content to be displayed (as defined by #imageMap)
 */
@Component({
  selector: 'app-static',
  imports: [MatProgressSpinnerModule, MatIconModule],
  templateUrl: './static.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './static.component.scss'
})
export class StaticComponent {
  /** The object input parameter */
  readonly object = input.required<string>();
  
  /** Static image url to display */
  imageUrl: string | null = null;

  /** Image flags */
  imageLoaded = false;
  imageError = false;

  /** Mapping of object names to image URLs */
  readonly #imageMap: Record<string, string> = {
    'mac-disclosure': 'https://storage.googleapis.com/transend-terms/mac/mac-disclosure-statement-and-account-customer-agreement.jpg',
  };

  /**
   * On construct, set up effect to load image when object input changes
   */
  constructor() {
    effect(() => {
      const objectParam = this.object();
      this._loadImage(objectParam);
    });
  }

  /**
   * Load image based on object param
   * 
   * @param objectParam object key to load image for
   */
  private _loadImage(objectParam: string): void {
    this.imageLoaded = false;
    this.imageError = false;
    
    const url = this.#imageMap[objectParam];
    if (url) {
      this.imageUrl = url;
    } else {
      this.imageError = true;
      this.imageUrl = null;
    }
  }

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  onImageError(): void {
    this.imageError = true;
    this.imageLoaded = false;
  }
}
